import { useAuthStore, mutateRequest } from "@/lib/swr";
import { RcTask, isRcTaskAssignee, refreshRcTasks } from "@/constants/rc";
import RcRejectButton from "@/components/rcs/rc-reject-button";
import TaskConfirmButton from "@/components/task-confirm/confirm-button";

// Inline actions on a review-flow node for its pending task: confirm
// (+ reject for approvals) — 节点上只放该节点的动作,截止时间是催办参数不是
// 操作项(要改去 Edit 对话框的 Flow tasks)。Rendered only for the task's own
// assignees — admins unblock stuck tasks via the edit dialog's Flow tasks
// section instead, so the timeline never invites acting on someone else's
// node. Confirming advances the flow, so the RC itself is revalidated
// alongside the task lists.
const RcTaskNodeActions = ({ task }: { task: RcTask }) => {
  const user = useAuthStore((s) => s.auth?.user);
  if (task.confirmedAt || task.rejectedAt) return null;
  if (!isRcTaskAssignee(task, user?.id)) return null;
  const refresh = () => {
    refreshRcTasks(task.rcId);
    mutateRequest(`/remote-configs/${task.rcId}`);
    mutateRequest("/remote-configs");
    mutateRequest("/remote-configs/stats");
  };
  return (
    <div className="mt-1.5 flex items-center gap-1.5">
      <TaskConfirmButton
        endpoint={`/rc-tasks/${task.id}/confirm`}
        onConfirmed={refresh}
        errorTitle="Cannot confirm task"
        variant="default"
      />
      {(task.type === "approve" ||
        task.type === "deploy-approve" ||
        task.type === "close-approve") && (
        <RcRejectButton
          taskId={task.id}
          rcId={task.rcId}
          review={
            task.type === "deploy-approve"
              ? "deploy"
              : task.type === "close-approve"
              ? "close"
              : undefined
          }
        />
      )}
    </div>
  );
};

export default RcTaskNodeActions;
